import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const crmLeadsWidget: DashboardWidgetConfiguration = {
  widgetId: "crm.leads",
  name: "New leads",
  description: "New leads for the selected dashboard period.",
  apps: [
    "home",
    "crm",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "crm.prospects",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "count_distinct",
          field: "prospect_id",
          as: "value",
        },
      ],
      where: {
        type: "condition",
        field: "prospect_type",
        operator: "eq",
        value: "lead",
      },
    },
  },
  inputs: {
    label: "Leads",
    subtext: "in the last 30 days",
    icon: "briefcase",
    color: "primary",
    valueFormat: "number",
    valueMultiplier: 1,
  },
  dummyData: {
    value: 38,
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 4,
    defaultHeight: 1,
  },
};
